import React from 'react';
import PropTypes from 'prop-types';

import { Route, Redirect } from 'react-router-dom';
import {HOME_ROUTE} from "../../../constants";


export const PublicRoute = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => {

    let path = localStorage.getItem('lastPath') || HOME_ROUTE;

    return (
        <Route { ...rest }
            component={ (props) => (
                ( !isAuthenticated )
                    ? ( <Component { ...props } /> )
                    : ( <Redirect to= {path} /> )
            )}

        />
    )
};

PublicRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}
